var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTab)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShown),expression:"isShown"}],class:_vm.tabClass,attrs:{"data-id":_vm.id && _vm.showId ? _vm.id : null}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }